import { Card } from '@mui/material';
import React from 'react';
import Texto from './Texto';

//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface Props {
    texto: string;
    titulo: string;
    icon?: JSX.Element;
    style?: React.CSSProperties;
    digitAnimated?: boolean;
}

function CardDato({ texto, titulo, icon, style, digitAnimated }: Props): JSX.Element {

    //Si tiene animacion habria que animar como que los numeros aumentan 
    const [animatedText, setAnimatedText] = React.useState(texto);

    React.useEffect(() => {
        if (digitAnimated) {
            let start = 0;
            const end = parseInt(texto);
            const duration = 1000; // Duración de la animación en milisegundos
            const increment = end / (duration / 16); // Incremento por frame

            const animate = () => {
                start += increment;
                if (start < end) {
                    setAnimatedText(Math.floor(start).toString());
                    requestAnimationFrame(animate);
                } else {
                    setAnimatedText(texto);
                }
            };

            requestAnimationFrame(animate);
        }
    }, [texto, digitAnimated]);

    return (
        <Card style={style}>
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '1em' }}>
                {icon && <div style={{ marginBottom: '0.5em' }}>{icon}</div>}
                <Texto style={{ margin: 0, fontSize: '1.5em', fontWeight: 'bold' }}>{digitAnimated ? animatedText : texto}</Texto>
                <Texto style={{ margin: 0, fontSize: '0.8em', color: 'gray' }}>{titulo}</Texto>
            </section>
        </Card>
    );
}

export default CardDato;
